import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { StackIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
// fallow-ignore-next-line circular-dependency
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';

const BulkPaymentsPage = lazyRouteComponent(() =>
  import('./BulkPaymentsPage').then((module) => ({
    default: module.BulkPaymentsPage,
  })),
);

/** Temporary tool: paste invoice numbers + a pay-by date, create payments. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/bulk-payments',
  staticData: {
    app: {
      nav: {
        label: msg('Bulk Payments', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <StackIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 31,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Create, subject: Subject.APInvoicePayment },
        ],
      },
    },
  },
  component: BulkPaymentsPage,
  loader: () => ({
    crumb: msg('Bulk Payments', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Create, subject: Subject.APInvoicePayment },
      ],
    });
  },
});
